// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-view-sites {
  background: white;
  border-right: 1px solid #cbd3db;
  box-sizing: border-box;
  position: relative;
  width: 320px;
}

.nametext {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 800px;
  height: 100%;
  z-index: 10;
}

.innernametext {
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
  font-size: 1rem;
}

.ngx-datatable.material,
.datatable-row-center,
datatable-header-cell {
  box-shadow: none;
}

.isSelected .datatable-row-center {
  background-color: #e3f5ff !important;
}

.header-menu {
  width: 90%;
  margin: 15px auto 0 auto;
}
.header-menu .head-menu {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.1em;
}

.container-search {
  width: 90%;
  margin: 15px auto 10px auto;
}
.container-search input {
  background: white;
  border: 1px solid #cbd3db;
  padding: 6px;
  border-radius: 1px;
}

.empty-row {
  font-size: 1.2rem;
  font-family: sans-serif;
}
.empty-row p {
  text-align: center;
}

.icon_settings {
  color: #c7c7c7;
  transition: transform 0.8s ease-in-out;
}
.icon_settings:hover {
  transform: rotate(360deg);
  background-color: none;
}

.datatable-body-cell {
  padding-right: 0 !important;
}

.button-add {
  line-height: 30px;
  padding: 0 15px !important;
}

.bloc-filter-name .search-filter-name {
  width: 100%;
  border-color: #e0e0e0;
  padding: 5px 10px;
  border-style: solid;
  border-right: none;
  border-left: none;
  font-size: 1.04rem;
  margin-top: 20px;
  box-shadow: none;
}

.icon-help-folder-info {
  position: absolute;
  top: 13px;
  z-index: 1;
  right: 13px;
}

.div-datatable-column {
  padding-bottom: 60px;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 700px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/view-sites/view-sites.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,+BAAA;EACA,sBAAA;EAEA,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;;;EAGE,gBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,UAAA;EACA,wBAAA;AAAF;AAEE;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,UAAA;EACA,2BAAA;AADF;AAGE;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AADJ;;AAKA;EACE,iBAAA;EACA,uBAAA;AAFF;AAIE;EACE,kBAAA;AAFJ;;AAMA;EAGE,cAAA;EAGA,sCAAA;AANF;AAQE;EAEE,yBAAA;EACA,sBAAA;AANJ;;AAUA;EACE,2BAAA;AAPF;;AAUA;EACE,iBAAA;EACA,0BAAA;AAPF;;AAWE;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AARJ;;AAYA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AATF;;AAYA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AATF","sourcesContent":[".app-view-sites {\r\n  background: white;\r\n  border-right: 1px solid #cbd3db;\r\n  box-sizing: border-box;\r\n  //float: left;\r\n  position: relative;\r\n  width: 320px;\r\n}\r\n\r\n.nametext {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 800px;\r\n  height: 100%;\r\n  z-index: 10;\r\n}\r\n\r\n.innernametext {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  margin-left: 10px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.ngx-datatable.material,\r\n.datatable-row-center,\r\ndatatable-header-cell {\r\n  box-shadow: none;\r\n}\r\n\r\n.isSelected .datatable-row-center {\r\n  background-color: #e3f5ff !important;\r\n}\r\n\r\n.header-menu {\r\n  width: 90%;\r\n  margin: 15px auto 0 auto;\r\n\r\n  .head-menu {\r\n    text-transform: uppercase;\r\n    font-weight: 700;\r\n    font-size: 1.1em;\r\n  }\r\n}\r\n\r\n.container-search {\r\n  width: 90%;\r\n  margin: 15px auto 10px auto;\r\n\r\n  input {\r\n    background: white;\r\n    border: 1px solid #cbd3db;\r\n    padding: 6px;\r\n    border-radius: 1px;\r\n  }\r\n}\r\n\r\n.empty-row {\r\n  font-size: 1.2rem;\r\n  font-family: sans-serif;\r\n\r\n  p {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.icon_settings {\r\n  //height: 100%;\r\n  //width: 100%;\r\n  color: #c7c7c7;\r\n  //font-size: 1.3rem;\r\n  -webkit-transition: -webkit-transform 0.8s ease-in-out;\r\n  transition: transform 0.8s ease-in-out;\r\n\r\n  &:hover {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n    background-color: none;\r\n  }\r\n}\r\n\r\n.datatable-body-cell {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.button-add {\r\n  line-height: 30px;\r\n  padding: 0 15px !important;\r\n}\r\n\r\n.bloc-filter-name {\r\n  .search-filter-name {\r\n    width: 100%;\r\n    border-color: #e0e0e0;\r\n    padding: 5px 10px;\r\n    border-style: solid;\r\n    border-right: none;\r\n    border-left: none;\r\n    font-size: 1.04rem;\r\n    margin-top: 20px;\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.icon-help-folder-info {\r\n  position: absolute;\r\n  top: 13px;\r\n  z-index: 1;\r\n  right: 13px;\r\n}\r\n\r\n.div-datatable-column {\r\n  padding-bottom: 60px;\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  height: 700px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
